import React, {useRef} from 'react';

import styles from './StringManipulation.module.scss';
import ToolBar from "../../../UI/ToolBar/ToolBar";
import Buttons from "../../../UI/ToolBar/Buttons";


export default function StringManipulation() {
    let textAreaRef = useRef();
    let inputRef = useRef();
    let checkRef = useRef();

    const reverseString = str => str.split("").reverse().join("");

    const capitalizeFirstLetter = str => str.charAt(0).toUpperCase() + str.slice(1);

    const invertCase = char => char === char.toUpperCase() ? char.toLowerCase() : char.toUpperCase();

    const deleteChars = char => {
        if (char === ' ') return char;
        let charactersToDelete = inputRef.current.value;
        if (!checkRef.current.checked) {
            charactersToDelete = charactersToDelete.toLowerCase();
            return charactersToDelete.includes(char.toLowerCase()) ? "" : char;
        }
        return charactersToDelete.includes(char) ? "" : char;
    }

    function handleDeleteChars() {
        let result = "";
        let {value} = textAreaRef.current;
        for (let i = 0; i < value.length; i++) {
            result += deleteChars(value[i]);
        }
        textAreaRef.current.value = result;
    }

    const buttons =
        [
            {
                tip: "Reset",
                clickHandler: () => textAreaRef.current.value = "",
                text: "Reset",
            },
            {
                tip: "Upper",
                clickHandler: () => {
                    let {value} = textAreaRef.current;
                    textAreaRef.current.value = value.toUpperCase();
                },
                text: "Upper",
            },
            {
                tip: "Lower",
                clickHandler: () => {
                    let {value} = textAreaRef.current;
                    textAreaRef.current.value = value.toLowerCase();
                },
                text: "Lower",
            },
            {
                tip: "Capitalize",
                clickHandler: () => {
                    let {value} = textAreaRef.current;
                    value = value.split(' ').map(capitalizeFirstLetter).join(' ');
                    textAreaRef.current.value = value;
                },
                text: "Capitalize",
            },
            {
                tip: "Reverse",
                clickHandler: () => {
                    let {value} = textAreaRef.current;
                    value = value.split(' ').reverse().map(reverseString).join(' ');
                    textAreaRef.current.value = value;

                },
                text: "Reverse",
            },
            {
                tip: "Swap case",
                clickHandler: () => {
                    let result = "";
                    let {value} = textAreaRef.current;
                    for (let i = 0; i < value.length; i++) {
                        result += invertCase(value[i]);
                    }
                    textAreaRef.current.value = result;
                },
                text: "Swap case",
            },
            {
                tip: "Trim",
                clickHandler: () => {
                    let {value} = textAreaRef.current;
                    textAreaRef.current.value = value.trim();
                },
                text: "Trim",
            },
        ]

    return (
        <div>
            <h1>String manipulation</h1>
            <ToolBar >
                <Buttons buttons={buttons} />
            </ToolBar>
            <textarea ref={textAreaRef} className={styles.InputArea} wrap="hard"/>
            <div className={styles.Actions}>
                <button onClick={handleDeleteChars}>Delete chars</button>
                <input ref={inputRef} type="text" maxLength="8"/>
                <label>Case sensitive</label>
                <input ref={checkRef} className={styles.checkBox} type="checkbox"/>
            </div>

        </div>

    );
}
